import {EventData} from '@/types/event';
import {isPast, parseISO} from 'date-fns';

export const isEventInPast = (event: EventData): boolean => {
  const {end} = event;

  if (!end) {
    return false;
  }

  let date: Date;

  if (typeof end === 'string') {
    date = parseISO(end);
  } else if (end instanceof Date) {
    date = end;
  } else {
    console.error('Invalid date format:', end);
    return false;
  }

  return isPast(date);
};
